// @flow
import React, {Component} from 'react';
import {isEmpty} from 'lodash';

import {Content as DestinationMessageContent} from './destinationMessage';

import type DestinationMessage from '@homeaway/graphql-traveler-urgency-messaging';

import './SearchBanner.less';

type Props = {
    urgencyMessage?: DestinationMessage
};

export class SearchBannerContainer extends Component<Props> {
    render() {
        const {urgencyMessage} = this.props;

        let isUrgencyMessage =
            !isEmpty(urgencyMessage) &&
            (!isEmpty(urgencyMessage.iconTitleText) ||
                !isEmpty(urgencyMessage.iconText));

        if (isUrgencyMessage) {
            return <DestinationMessageContent {...urgencyMessage} />;
        }

        return null;
    }
}

export default SearchBannerContainer;
